import { Suspense, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
// import LogoTitle from '../../assets/images/logo-s.png'
import LogoTitle from '../../assets/images/temi-logo-s.gif'
import temiLogo from '../../assets/images/logo512.png'
import useWindowDimensions from '../hooks/useWindowDimensions'
import Logo from './Logo'
import './index.scss'

const Home = () => {
  const { width } = useWindowDimensions()

  const [letterClass, setLetterClass] = useState('text-animate')

  const nameArray = [
    'S',
    'h',
    'i',
    'n',
    'a',
    ' ',
    'A',
    'l',
    'a',
    'n',
    'i',
    ' ,',
  ]
  const jobArray = [
    'F',
    'u',
    'l',
    'l',
    ' ',
    'S',
    't',
    'a',
    'c',
    'k',
    '',
    'D',
    'e',
    'v',
    'e',
    'l',
    'o',
    'p',
    'e',
    'r',
    '.',
  ]

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)
  }, [])

  return (
    <>
      <div className={`container home-page ${width < 768 ? 'my-20' : ''}`}>
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i,</span>
            <br />
            <span className={`${letterClass} _13`}>I</span>
            <span
              className={`${letterClass} _14`}
              style={{ paddingRight: '10px' }}
            >
              'm
            </span>

            <AnimatedLetters
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
              mobileView={width < 768 ? true : false}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={22}
              mobileView={width < 768 ? true : false}
            />
          </h1>
          <h2>
            Front End Developer / JavaScript Expert / SEO Expert / Crypto Ninja
          </h2>
          <Link to="/contact" className="flat-button">
            CONTACT ME
          </Link>
        </div>
        <Logo />
      </div>

      <Loader type="pacman" />
    </>
  )
}

export default Home
